type Stage = {
  icon: string;
  title: string;
  bullets: readonly string[];
};

const STAGES: readonly Stage[] = [
  {
    icon: "/business/b2b1.svg",
    title: "Understand the team",
    bullets: [
      "Map current workflows and tools",
      "Identify key friction points",
      "Align on real team needs before building",
    ],
  },
  {
    icon: "/business/b2b2.svg",
    title: "Align the Format Mix",
    bullets: [
      "Tailor learning to team size and goals",
      "Blend live sessions, recordings, content",
      "Create a format that actually fits daily work",
    ],
  },
  {
    icon: "/business/b2b3.svg",
    title: "Deliver Live & Async",
    bullets: [
      "Run structured, hands-on live sessions",
      "Record and organize everything for reuse",
      "Enable learning on individual schedules",
    ],
  },
  {
    icon: "/business/b2b4.svg",
    title: "Reinforce Daily",
    bullets: [
      "Share bite-sized updates via WhatsApp",
      "Keep concepts active through weekly nudges",
      "Build consistency without extra effort",
    ],
  },
  {
    icon: "/business/b2b5.svg",
    title: "Support Continued Adoption",
    bullets: [
      "Continuously update learning content",
      "Layer ongoing support over time",
      "Prevent drop-off after initial sessions",
    ],
  },
];

function StageCard({ stage, index }: { stage: Stage; index: number }) {
  return (
    <div
      className="relative shrink-0 overflow-hidden rounded-2xl border bg-cover bg-center w-full md:w-[335px] md:h-[320px] p-6"
      style={{
        borderColor: "#FFFFFF33",
        backgroundImage: "url(/business/b2bcard.webp)",
      }}
    >
      <div className="flex h-full flex-col">
        <img
          src={stage.icon}
          alt=""
          className="h-8 w-8"
          loading="lazy"
          decoding="async"
        />
        <p className="mt-6 text-[10px] font-medium uppercase tracking-[0.18em] text-white/70">
          Stage {index + 1}
        </p>
        <h3 className="mt-2 text-[17px] font-semibold leading-snug text-white">
          {stage.title}
        </h3>
        <ul className="mt-4 flex flex-col gap-2">
          {stage.bullets.map((b, i) => (
            <li key={i} className="flex items-start gap-2">
              <img
                src="/business/b2btick.svg"
                alt=""
                className="mt-0.5 h-4 w-4 shrink-0"
                loading="lazy"
                decoding="async"
              />
              <span className="text-[13px] leading-snug text-white/70">
                {b}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function BusinessStages() {
  return (
    <section
      id="business-stages"
      className="w-full font-fira text-white py-12 md:py-20"
      style={{ backgroundColor: "#10100F" }}
    >
      <div className="mx-auto w-[90%] md:w-[80%]">
        <p className="font-fira text-sm font-normal uppercase tracking-[0.18em] text-[#FFFFFF]">
          How engagements work
        </p>
        <h2 className="mt-3 font-fira-condensed text-[30px] font-medium leading-tight tracking-tight text-white md:mt-4 md:text-[42px] md:font-semibold">
          A Five-stage engagement model
        </h2>
        <p className="mt-3 font-fira text-sm font-normal leading-relaxed text-[#FFFFFF85] md:mt-4 md:text-base">
          Most engagements run across 8 to 12 weeks with ongoing support built
          in.
        </p>
      </div>

      <div className="mx-auto mt-8 flex w-[90%] flex-col gap-4 md:hidden">
        {STAGES.map((stage, i) => (
          <StageCard key={stage.title} stage={stage} index={i} />
        ))}
      </div>

      <div
        className="mt-12 hidden overflow-x-auto pb-4 md:block"
        style={{ scrollbarWidth: "thin" }}
      >
        <div className="flex gap-5 pl-[10%] pr-[10%]">
          {STAGES.map((stage, i) => (
            <StageCard key={stage.title} stage={stage} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
